// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LigLsO59elAYgG {
  padding: var(--ds-space-150, 10px);
}
.LigLsO59elAYgG .XbcPJxEltuuwhF {
  font-weight: var(--ds-font-weight-regular, 400);
}
.LigLsO59elAYgG .bHvxfQeSwCAQxG {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-300, 25px);
}
.LigLsO59elAYgG .NKaxiHUTTiXMUl {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.LigLsO59elAYgG .sfgnEaByKqBtks {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
  overflow-wrap: break-word;
  font-size: 26px;
}
.LigLsO59elAYgG .csry2GeGcCmNjJ,
.LigLsO59elAYgG .BWQjWEq53qwm8Y,
.LigLsO59elAYgG .jbKdn4J1CMGkzr {
  font-weight: var(--ds-font-weight-regular, 400);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.LigLsO59elAYgG .BWQjWEq53qwm8Y {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: var(--ds-space-400, 32px) var(--ds-space-300, 25px) var(--ds-space-300, 25px) 30px;
}
.LigLsO59elAYgG:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.LigLsO59elAYgG:nth-last-child(2) .bHvxfQeSwCAQxG {
  margin-top: var(--ds-space-050, 3px);
}
.LigLsO59elAYgG:nth-last-child(2)::before {
  margin-top: var(--ds-space-250, 20px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  content: attr(data-value);
  position: relative;
  top: var(--ds-space-negative-200, -15px);
  width: 85px;
  height: 24px;
  padding: var(--ds-space-075, 5px);
  border-radius: var(--ds-border-radius-050, 2px);
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
export var planCell = `LigLsO59elAYgG`;
export var purchase = `XbcPJxEltuuwhF`;
export var name = `bHvxfQeSwCAQxG`;
export var info = `NKaxiHUTTiXMUl`;
export var price = `sfgnEaByKqBtks`;
export var frequency = `csry2GeGcCmNjJ`;
export var pricingVaries = `BWQjWEq53qwm8Y`;
export var currentPlan = `jbKdn4J1CMGkzr`;
export default ___CSS_LOADER_EXPORT___;
